/**
 * Marks a venue-create field whose value was pre-filled from the venue's
 * domain rather than typed by the operator.
 *
 * Split out of venueCreateFields.tsx (BON-586): that module held three
 * components, so `react/no-multi-comp` failed the moment it was edited.
 */
import { Sparkles } from 'lucide-react';

export function SuggestTag() {
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        fontSize: 9,
        fontWeight: 700,
        letterSpacing: '.05em',
        textTransform: 'uppercase',
        color: 'var(--nb-primary)',
      }}
    >
      <Sparkles size={10} /> suggested from domain
    </span>
  );
}
